<mat-toolbar class="background-color-green" style=" position: sticky; top: 0;  z-index: 7;">            
    <a [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>        
    <span class="text-color-white">{{ 'ml_143977' | translate }}</span>
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading" >
    <mat-list>              
      <mat-card class="example-card mat-card-background-color-white-smoke">
        <mat-card-header >          
          <mat-card-title style="width: 360px; font-weight: 600; " class="text-color-green">
            {{ 'ml_151035' | translate }}
            <span class="text-color-blue">{{driverServiceDay}}</span>
            {{ 'ml_151121' | translate }} 
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>                                
        </mat-card-content>  
      </mat-card>
      <mat-card class="example-card mat-card-background-color-white-smoke">
        <mat-card-header>                    
          <div>
            <mat-card-title>
              <span style="width: 360px; font-size: 18px;" class="text-color-green">
                {{ 'ml_144095' | translate }}: <span class="text-color-blue">{{totalMilesage}}</span> {{ 'ml_144022' | translate }}
              </span>
              <span style="font-family:  Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); text-indent: 10px; font-size: 14px;">
                {{ 'ml_151180' | translate }}: {{totalMilesageStartDay}}
              </span>
            </mat-card-title>
            <!-- <mat-card-subtitle  style="font-family:  Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); text-indent: 10px;">
              
            </mat-card-subtitle> -->
  
            <mat-divider *ngIf="driverBusinessType === 'PG'" style="margin-top: 10px; margin-bottom: 10px;"></mat-divider>

            <mat-card-title *ngIf="driverBusinessType === 'PG'">
              <span style="width: 360px; font-size: 18px;" class="text-color-green">
                {{ 'ml_144017' | translate }}: <span class="text-color-blue">{{totalCylinder}}</span> {{ 'ml_144023' | translate }}
              </span>
              <span style="font-family:  Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); font-size: 14px;">
                {{ 'ml_151180' | translate }}: {{totalCylinderStartDay}}
              </span>
            </mat-card-title>
            <!-- <mat-card-subtitle  *ngIf="driverBusinessType === 'PG'" style="font-family:  Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); text-indent: 10px;">
              {{ 'ml_151180' | translate }}: <span >{{totalCylinderStartDay}}</span>
            </mat-card-subtitle> -->
          </div>
          
        </mat-card-header>
        <mat-card-content>                                
        </mat-card-content>  
      </mat-card>      
        @if(myAchievementObjectArray.myAwards.length === 0){
          
        }
        @else {          
          <mat-list-item >            
            <span class="font-weight-600 text text-color-blue font-size-22px">{{ 'ml_151028' | translate }}</span>
            <button mat-raised-button style="background-color: #00BFFF; color: white; float: right;" (click)="showMoreAward()" class="text-color-blue"
            *ngIf="myAchievementObjectArray.myAwards.length > 1">{{moreOrLess}}</button>                         
          </mat-list-item>
          @for (myAwardObject of myAchievementObjectArray.myAwards.slice(0, 1); track myAwardObject) {
            <mat-card class="example-card mat-card-background-color-white-smoke">
              <mat-card-header >
                <mat-card-title-group>
                  <mat-card-title style="width: 360px;">
                    <div style="display: flex;">
                      <div class="text-color-green" style="font-size: 18px;">{{ myAwardObject.awardname }}</div>
                      <div style="flex: 1;"></div>
                      <div class="text-color-blue" style="font-size: 14px;">{{ formatDate(myAwardObject.awardDate) }}</div>
                    </div>
                  </mat-card-title>
                  
                
                </mat-card-title-group>
              </mat-card-header>
              <mat-card-content>
                                      
              </mat-card-content>  
            </mat-card>
          }                    
          @if(toShowMoreAward){
            @for (myAwardObject of myAchievementObjectArray.myAwards.slice(1); track myAwardObject) {
              <mat-card class="example-card mat-card-background-color-white-smoke">
                <mat-card-header >
                  <mat-card-title-group>
                    <mat-card-title style="width: 360px;">
                      <div style="display: flex;">
                        <div class="text-color-green" style="font-size: 18px;">{{ myAwardObject.awardname }}</div>
                        <div style="flex: 1;"></div>
                        <div class="text-color-blue" style="font-size: 14px;">{{ formatDate(myAwardObject.awardDate) }}</div>
                      </div>
                    </mat-card-title>
                    
                  
                  </mat-card-title-group>
                </mat-card-header>
                <mat-card-content>
                                        
                </mat-card-content>  
              </mat-card>
            }
          }
          <!-- <mat-list-item *ngIf="myAchievementObjectArray.myAwards.length > 1">
            <button  mat-raised-button style="background-color: #00BFFF; color: white; float: right;" (click)="showMoreAward()" class="text-color-blue">{{moreOrLess}}</button>          
          </mat-list-item> -->
        }
        <mat-divider></mat-divider>
        @if(myAchievementObjectArray.myAchievements.length === 0){
          
        }
        @else {
          <mat-list-item>            
            <span class="font-weight-600 text text-color-blue font-size-22px">{{ 'ml_144015' | translate }}</span>            
          </mat-list-item>    
          @for (myAchievementObject of myAchievementObjectArray.myAchievements; track myAchievementObject) {
            <mat-card class="example-card mat-card-background-color-white-smoke" *ngIf=" !( myAchievementObject.achievementName === 'Total Mileage' || myAchievementObject.achievementName === 'Number of Cylinders Delivered' ) ">
                <mat-card-header style="padding-right: 0px;">
                    <mat-card-title-group >
                      <mat-card-title style="width: 384px;">
                        <span class="text-color-green" style="font-size: 16px;">
                          {{ myAchievementObject.achievement_Translation_Id  | translate }} 
                        </span>
                        <span class="text-color-blue" style="font-size: 16px;">
                          {{myAchievementObject.achieveValue}} {{ myAchievementObject.uom_Translation_Id  | translate }}
                        </span>                         
                        <span style="font-family: Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); font-size: 12px;">
                          {{ 'ml_151180' | translate }}: {{ formatDateString(myAchievementObject.achievementInitDate) }}
                        </span>
                      </mat-card-title>
                      
                      <!-- <mat-card-subtitle  style="font-family:  Roboto, sans-serif; color: rgba(0, 0, 0, 0.54); text-indent: 10px;">
                        <div style="padding-bottom: 4px;">
                          {{ 'ml_151180' | translate }}: <span >{{ formatDateString(myAchievementObject.achievementInitDate) }}</span>
                        </div>
                        
                      </mat-card-subtitle > -->
                      <mat-card-subtitle style="width: 384px;" 
                      *ngIf="myAchievementObject.milestoneId !== null && myAchievementObject.milestone > myAchievementObject.achieveValue"> 
                        <div style="display: flex;">
                          <div style="width: 260px; padding-top: 12px; font-size: 12px;">

                            {{ 'ml_151223' | translate: { milestone: myAchievementObject.milestone_Translation_Id | translate , gap: myAchievementObject.milestone - myAchievementObject.achieveValue, uom: myAchievementObject.uom_Translation_Id  | translate } }}
                          </div>
                          <!-- <div style="flex: 1;"></div> -->
                            <div style="width: 100px;">
                              <app-angular-progress-bar *ngIf="myAchievementObject.milestoneId !== null" [progress]="myAchievementObject.completePercent" [color]="'#32de84'"></app-angular-progress-bar>
                            </div>
                        </div>
                        
                      </mat-card-subtitle>
                    </mat-card-title-group>
                  </mat-card-header>
                  <mat-card-content >
                    
                          <mat-expansion-panel *ngIf="myAchievementObject.achievedMilestoneObject !== null"  [hideToggle]="myAchievementObject.achievedMilestoneObject === null" [disabled]="myAchievementObject.achievedMilestoneObject === null">
                            <mat-expansion-panel-header>                    
                              <mat-panel-title class="flex-basis-200px text-color-green" style="color: #009947;" >                        
                                {{ 'ml_151205' | translate }}                                 
                              </mat-panel-title>
                              <mat-panel-description class="text-color-blue" style="color: #00BFFF;">
                                  {{ myAchievementObject.achievedMilestoneObject === null ? 0 : myAchievementObject.achievedMilestoneObject.milestoneArray.length}}
                              </mat-panel-description>
                            </mat-expansion-panel-header>
                            @if(myAchievementObject.achievedMilestoneObject !== null){
                              
                              @for (milestone of myAchievementObject.achievedMilestoneObject.milestoneArray; track milestone) {
                                <mat-card class="example-card mat-card-background-color-white-smoke">
                                    <mat-card-header>
                                        <mat-card-title>                                
                                            <span class="text-color-green font-size-14px">{{ formatDate( milestone.milestoneDate ) }} </span>
                                            <span class="example-spacer"></span>
                                            <span class="text-color-blue font-size-14px">{{ milestone.milestone_Translation_Id | translate }}</span> 
                                        </mat-card-title>
                                        <mat-card-subtitle>
                                        </mat-card-subtitle> 
                                    </mat-card-header> 
                                    <mat-card-content>
                                      
                                    </mat-card-content>                         
                                </mat-card>
                              }
                            }                            
                          </mat-expansion-panel>                    
                  </mat-card-content>                  
            </mat-card>
          }
        }
    </mat-list>
</div>






